var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ellipsis",class:_vm.colorClass,style:({'left': _vm.positionLeft})},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }